import React from "react";
export var SelectableAddon = function SelectableAddon(_ref) {
  var children = _ref.children,
      _ref$index = _ref.index,
      index = _ref$index === void 0 ? 0 : _ref$index,
      _ref$chainId = _ref.chainId,
      chainId = _ref$chainId === void 0 ? 0 : _ref$chainId,
      _ref$groupId = _ref.groupId,
      groupId = _ref$groupId === void 0 ? 0 : _ref$groupId,
      _ref$optionId = _ref.optionId,
      optionId = _ref$optionId === void 0 ? 0 : _ref$optionId,
      _ref$inputType = _ref.inputType,
      inputType = _ref$inputType === void 0 ? "radio" : _ref$inputType,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? true : _ref$required,
      _ref$onChange = _ref.onChange,
      _onChange = _ref$onChange === void 0 ? function () {
    return "";
  } : _ref$onChange,
      isOption = _ref.isOption,
      defaultOption = _ref.defaultOption,
      _ref$additionalCost = _ref.additionalCost,
      additionalCost = _ref$additionalCost === void 0 ? 0 : _ref$additionalCost,
      controlledValues = _ref.controlledValues,
      control = _ref.control,
      _ref$displayName = _ref.displayName,
      displayName = _ref$displayName === void 0 ? "Yup" : _ref$displayName,
      isEditMode = _ref.isEditMode;

  var name = groupId;
  var idName = chainId; //Allows both controlled and uncontrolled input

  var isChecked;

  if (defaultOption == true) {
    isOption = true;
  } else if (!controlledValues) {
    isChecked = control;
  } else {
    isChecked = controlledValues.filter(function (value) {
      return displayName.toLowerCase() === value.optionName.toLowerCase();
    }).length !== 0;
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("input", {
    type: inputType,
    name: name,
    id: optionId,
    value: {
      name: optionId
    },
    className: "visuallyhidden",
    required: required,
    checked: isChecked,
    defaultChecked: isOption,
    onChange: function onChange(elem) {
      return _onChange(idName, optionId, additionalCost, displayName, elem);
    }
  }), /*#__PURE__*/React.createElement("label", {
    htmlFor: optionId,
    className: "cb-menu-detail__selectable-addon"
  }, children));
};